const globalReducer = (state: any, action: any) => {
  if (!state) return null;
  switch (action.type) {
    case 'SET_ADVERTISER':
      return {
        ...state,
        id: action.id,
        name: action.name,
        apiKey: action.apiKey,
      };

    case 'UNSET_ADVERTISER':
      return {
        ...state,
        id: null,
        name: null,
        apiKey: null,
      };

    default:
      return state;
  }
};

export default globalReducer;
